var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0708 22.146L21.81 15.4237L12.0001 13.0604L2.19024 15.4237L0.930724 22.1461C0.88504 22.3899 1.07215 22.6154 1.32026 22.6154H22.6812C22.9294 22.6154 23.1165 22.3899 23.0708 22.146Z",
    fill: "url(#paint0_linear_2258_1049)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6133 13.1539L12.0014 13.0602L12.3901 13.1539H11.6133Z",
    fill: "url(#paint1_linear_2258_1049)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.986327 21.8496H23.0152L23.0708 22.1461C23.1165 22.39 22.9294 22.6154 22.6812 22.6154H1.32026C1.07212 22.6154 0.884992 22.39 0.930741 22.1461L0.986327 21.8496Z",
    fill: "url(#paint2_linear_2258_1049)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.81 15.4237L12.0001 13.0604L2.19024 15.4237L0.986328 21.8496C14.7105 21.3426 20.8411 16.4712 21.8345 15.5543L21.81 15.4237Z",
    fill: "url(#paint3_linear_2258_1049)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17276 8.90234H19.8295C21.1427 8.90234 22.2073 9.96693 22.2073 11.2802V13.8124C22.2073 14.0313 22.0298 14.2087 21.811 14.2087H2.19123C1.97237 14.2087 1.79492 14.0313 1.79492 13.8124V11.2802C1.79492 9.96693 2.85953 8.90234 4.17276 8.90234Z",
    fill: "url(#paint4_linear_2258_1049)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8295 10.8374H4.17276C2.85951 10.8374 1.79492 11.902 1.79492 13.2152V15.7474C1.79492 15.9663 1.97237 16.1437 2.19123 16.1437H21.811C22.0298 16.1437 22.2073 15.9663 22.2073 15.7474V13.2152C22.2073 11.902 21.1427 10.8374 19.8295 10.8374Z",
    fill: "url(#paint5_linear_2258_1049)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 1.38477C10.3299 1.38477 9.07464 2.91231 9.39892 4.55323L10.4089 9.65991C10.4154 9.6915 10.4238 9.72309 10.4368 9.7519C10.8837 10.7526 13.1862 10.7647 13.5727 9.74353C13.582 9.71937 13.5876 9.69521 13.5932 9.67012L14.605 4.55323C14.9293 2.91231 13.674 1.38477 12.0015 1.38477Z",
    fill: "url(#paint6_linear_2258_1049)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 6.17971C12.7903 6.17971 13.4311 5.42346 13.4311 4.4892C13.4311 3.55494 12.7903 2.79761 12.0017 2.79761C11.212 2.79761 10.5723 3.55494 10.5723 4.4892C10.5723 5.42346 11.212 6.17971 12.0017 6.17971Z",
    fill: "url(#paint7_linear_2258_1049)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5643 14.2846C16.2406 14.2846 16.7888 13.7364 16.7888 13.0602C16.7888 12.3839 16.2406 11.8357 15.5643 11.8357C14.8881 11.8357 14.3398 12.3839 14.3398 13.0602C14.3398 13.7364 14.8881 14.2846 15.5643 14.2846Z",
    fill: "url(#paint8_radial_2258_1049)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7234 13.1432L16.0253 13.5208L15.6477 13.2185L15.5647 13.9671L15.4821 13.2185L15.1045 13.5208L15.4064 13.1432L14.6582 13.0601L15.4064 12.9771L15.1045 12.6L15.4821 12.9018L15.5647 12.1537L15.6477 12.9018L16.0253 12.6L15.7234 12.9771L16.4716 13.0601L15.7234 13.1432Z",
    fill: "url(#paint9_radial_2258_1049)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79492 15.7474V13.2152C1.79492 11.902 2.85953 10.8374 4.17276 10.8374H19.8295C21.1427 10.8374 22.2073 11.902 22.2073 13.2152V15.7474C22.2073 15.9452 22.062 16.1078 21.8726 16.1375C22.0027 16.1139 22.1174 16.0224 22.1653 15.9014C22.1952 15.8313 22.1962 15.7573 22.1924 15.6799L22.1875 15.45L22.1725 14.5302C22.1624 13.3396 22.1575 12.9903 22.0856 12.709C21.8626 11.744 21.026 11.0212 20.0406 10.9425L19.8195 10.934C9.84589 10.9792 13.9095 10.9789 4.18269 10.9345L3.96169 10.9429C2.97514 11.0215 2.13917 11.7458 1.91701 12.709C1.85362 12.957 1.84171 13.1541 1.82995 14.5302L1.81489 15.45L1.8099 15.6799C1.80611 15.7574 1.80711 15.8313 1.83699 15.9014C1.88481 16.0224 1.99956 16.1139 2.12972 16.1375C1.94026 16.1078 1.79492 15.9452 1.79492 15.7474Z",
    fill: "#DF9CEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2258_1049",
    x1: 18.2888,
    y1: 17.8381,
    x2: 4.19198,
    y2: 17.8381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#A2B9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA6AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2258_1049",
    x1: 23.0779,
    y1: 13.1073,
    x2: 0.924046,
    y2: 13.1073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#A2B9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA6AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2258_1049",
    x1: 4.04014,
    y1: 22.2324,
    x2: 16.1366,
    y2: 22.2324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#A2B9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA6AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2258_1049",
    x1: 11.7977,
    y1: 25.5236,
    x2: 11.0892,
    y2: 13.0441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#A2B9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA6AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2258_1049",
    x1: 22.2075,
    y1: 11.5556,
    x2: 1.79506,
    y2: 11.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#BD5DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#9A43BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2258_1049",
    x1: 1.79506,
    y1: 13.4904,
    x2: 22.2075,
    y2: 13.4904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#BD5DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#9A43BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2258_1049",
    x1: 8.53656,
    y1: 5.94513,
    x2: 14.0146,
    y2: 5.94513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#BD5DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#9A43BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2258_1049",
    x1: 14.3507,
    y1: 4.48853,
    x2: 10.7849,
    y2: 4.48853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#BD5DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#9A43BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2258_1049",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5643 13.0602) scale(1.22446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2258_1049",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5647 13.0601) scale(0.906923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningBrush);
export default __webpack_public_path__ + "static/media/cleaning-brush.001ea4c1d9e308f5a6242b8bbc23f063.svg";
export { ForwardRef as ReactComponent };